/** O endereço que abre o tópico de um pin no módulo BCF, ou null quando
 *  não há onde o abrir (modo local, workspace sem o módulo, pin sem BCF
 *  ou sem tópico). Usa o `?topic=` que a lista do módulo já entende
 *  (BcfTopicsView): acrescenta o tópico aos abertos, sem fechar nenhum. */
export function enderecoDoTopico(o: {
  modoCloud: boolean
  workspace: string | null
  moduloBcf: boolean
  bcfLocalId: string | null
  topicGuid: string | null
}): string | null {
  if (!o.modoCloud || !o.workspace || !o.moduloBcf || !o.bcfLocalId || !o.topicGuid) return null
  return `/${o.workspace}/bcf/${encodeURIComponent(o.bcfLocalId)}?topic=${encodeURIComponent(o.topicGuid)}`
}

/** Navega para `destino` dentro da aplicação sem precisar dos hooks do
 *  router: o BrowserRouter ouve o `popstate`. Não faz nada quando já se
 *  está lá. */
export function irPara(destino: string, w: Window = window): void {
  const actual = `${w.location.pathname}${w.location.search}`
  if (actual === destino) return
  w.history.pushState({}, '', destino)
  w.dispatchEvent(new PopStateEvent('popstate'))
}
